
const API_ROOTT = 'https://app-node-talkcmo.ondotmail.com:5030';
const API_ROOT = 'https://app-node.talkcmo.com:3019';


// const webPath = 'https://talkcmo.ondotmail.com'
const webPath = 'https://talkcmo.com'


export { API_ROOT , webPath,API_ROOTT};